import {
  COUPON_EVENT_AMOUNT,
  COUPON_EVENT_BARRIER_TOUCH,
  COUPON_EVENT_CAP,
  COUPON_EVENT_CAP_FLOOR,
  COUPON_EVENT_COUPON,
  COUPON_EVENT_COUPON_TYPE,
  COUPON_EVENT_CURRENCY,
  COUPON_EVENT_DAY_COUNT_FRACTION,
  COUPON_EVENT_DENOMINATION,
  COUPON_EVENT_FLOOR,
  COUPON_EVENT_MULTIPLIER,
  COUPON_EVENT_REFERENCE_RATE,
  COUPON_EVENT_REFERENCE_RATE_FIX,
  COUPON_EVENT_SCHEDULE_FIXING_DATE,
  COUPON_EVENT_SCHEDULE_PAYMENT_DATE,
  COUPON_EVENT_SCHEDULE_PAYMENT_FIXING,
  COUPON_EVENT_SCHEDULE_START_END,
  COUPON_EVENT_SPREAD,
} from './coupon-event-field-selectors.consts';

import { FCForm } from '../../model/form-config.interface';
import {
  LifecycleEventType,
  LifecycleEventTypeLabel,
} from 'src/app/lifecycle-events/models/lifecycle-event-type.enum';

const CONDITIONAL_OR_SNOWBALL_EFFECTS = [
  {
    formControlNames: [
      COUPON_EVENT_REFERENCE_RATE,
      COUPON_EVENT_REFERENCE_RATE_FIX,
      COUPON_EVENT_SCHEDULE_FIXING_DATE,
      COUPON_EVENT_SPREAD,
      COUPON_EVENT_MULTIPLIER,
    ],
    hidden: true,
  },
  {
    formControlNames: [
      COUPON_EVENT_SCHEDULE_START_END,
      COUPON_EVENT_SCHEDULE_PAYMENT_DATE,
      COUPON_EVENT_COUPON,
      COUPON_EVENT_DAY_COUNT_FRACTION,
      COUPON_EVENT_DENOMINATION,
      COUPON_EVENT_CAP_FLOOR,
      COUPON_EVENT_BARRIER_TOUCH,
      COUPON_EVENT_CURRENCY,
    ],
    hidden: false,
    readOnly: true,
  },
];

const ISSUE_OR_INITIAL_FIXING_OR_FINAL_FIXING_EFFECTS = [
  {
    formControlNames: [
      COUPON_EVENT_COUPON,
      COUPON_EVENT_SCHEDULE_PAYMENT_FIXING,
      COUPON_EVENT_DAY_COUNT_FRACTION,
      COUPON_EVENT_REFERENCE_RATE,
      COUPON_EVENT_REFERENCE_RATE_FIX,
      COUPON_EVENT_DENOMINATION,
      COUPON_EVENT_FLOOR,
      COUPON_EVENT_CAP,
      COUPON_EVENT_MULTIPLIER,
      COUPON_EVENT_SPREAD,
      COUPON_EVENT_CURRENCY,
      COUPON_EVENT_BARRIER_TOUCH,
      COUPON_EVENT_AMOUNT,
    ],
    hidden: true,
  },
  {
    formControlNames: [COUPON_EVENT_SCHEDULE_START_END],
    readOnly: true,
    hidden: false,
  },
];

export const COUPON_EVENT: FCForm = {
  name: 'couponEvent',
  fields: [
    {
      formControlNames: [COUPON_EVENT_COUPON_TYPE],
      options: [
        {
          id: LifecycleEventTypeLabel[LifecycleEventType.FIXED],
          label: LifecycleEventTypeLabel[LifecycleEventType.FIXED],
          effects: [
            {
              formControlNames: [
                COUPON_EVENT_REFERENCE_RATE,
                COUPON_EVENT_REFERENCE_RATE_FIX,
                COUPON_EVENT_BARRIER_TOUCH,
                COUPON_EVENT_SCHEDULE_FIXING_DATE,
                COUPON_EVENT_MULTIPLIER,
                COUPON_EVENT_SPREAD,
                COUPON_EVENT_CAP_FLOOR,
              ],
              hidden: true,
            },
            {
              formControlNames: [
                COUPON_EVENT_SCHEDULE_START_END,
                COUPON_EVENT_SCHEDULE_PAYMENT_DATE,
                COUPON_EVENT_DAY_COUNT_FRACTION,
                COUPON_EVENT_COUPON,
                COUPON_EVENT_DENOMINATION,
                COUPON_EVENT_CURRENCY,
              ],
              readOnly: true,
              hidden: false,
            },
          ],
        },
        {
          id: LifecycleEventTypeLabel[LifecycleEventType.FLOATING],
          label: LifecycleEventTypeLabel[LifecycleEventType.FLOATING],
          effects: [
            {
              formControlNames: [
                COUPON_EVENT_BARRIER_TOUCH,
                COUPON_EVENT_SCHEDULE_FIXING_DATE,
              ],
              hidden: true,
            },
            {
              formControlNames: [
                COUPON_EVENT_COUPON,
                COUPON_EVENT_REFERENCE_RATE_FIX,
              ],
              hidden: false,
              readOnly: false,
            },
            {
              formControlNames: [
                COUPON_EVENT_SCHEDULE_START_END,
                COUPON_EVENT_SCHEDULE_PAYMENT_DATE,
                COUPON_EVENT_DAY_COUNT_FRACTION,
                COUPON_EVENT_DENOMINATION,
                COUPON_EVENT_FLOOR,
                COUPON_EVENT_CAP,
                COUPON_EVENT_REFERENCE_RATE,
                COUPON_EVENT_CURRENCY,
                COUPON_EVENT_MULTIPLIER,
                COUPON_EVENT_SPREAD,
              ],
              readOnly: true,
              hidden: false,
            },
          ],
        },
        {
          id: LifecycleEventTypeLabel[LifecycleEventType.CONDITIONAL],
          label: LifecycleEventTypeLabel[LifecycleEventType.CONDITIONAL],
          effects: [...CONDITIONAL_OR_SNOWBALL_EFFECTS],
        },
        {
          id: LifecycleEventTypeLabel[LifecycleEventType.SNOWBALL],
          label: LifecycleEventTypeLabel[LifecycleEventType.SNOWBALL],
          effects: [...CONDITIONAL_OR_SNOWBALL_EFFECTS],
        },
        {
          id: LifecycleEventTypeLabel[LifecycleEventType.REDEMPTION],
          label: LifecycleEventTypeLabel[LifecycleEventType.REDEMPTION],
          effects: [
            {
              formControlNames: [
                COUPON_EVENT_COUPON,
                COUPON_EVENT_SCHEDULE_PAYMENT_FIXING,
                COUPON_EVENT_DAY_COUNT_FRACTION,
                COUPON_EVENT_REFERENCE_RATE,
                COUPON_EVENT_REFERENCE_RATE_FIX,
                COUPON_EVENT_DENOMINATION,
                COUPON_EVENT_FLOOR,
                COUPON_EVENT_CAP,
                COUPON_EVENT_MULTIPLIER,
                COUPON_EVENT_SPREAD,
                COUPON_EVENT_CURRENCY,
                COUPON_EVENT_BARRIER_TOUCH,
                COUPON_EVENT_SCHEDULE_START_END,
              ],
              hidden: true,
            },
            {
              formControlNames: [COUPON_EVENT_CURRENCY],
              hidden: false,
              readOnly: true,
            },
            {
              formControlNames: [COUPON_EVENT_AMOUNT],
              hidden: false,
              readOnly: false,
            },
          ],
        },
        {
          id: LifecycleEventTypeLabel[LifecycleEventType.AUTOCALL],
          label: LifecycleEventTypeLabel[LifecycleEventType.AUTOCALL],
          effects: [
            {
              formControlNames: [
                COUPON_EVENT_COUPON,
                COUPON_EVENT_SCHEDULE_PAYMENT_DATE,
                COUPON_EVENT_DAY_COUNT_FRACTION,
                COUPON_EVENT_REFERENCE_RATE,
                COUPON_EVENT_REFERENCE_RATE_FIX,
                COUPON_EVENT_DENOMINATION,
                COUPON_EVENT_FLOOR,
                COUPON_EVENT_CAP,
                COUPON_EVENT_MULTIPLIER,
                COUPON_EVENT_SPREAD,
                COUPON_EVENT_SCHEDULE_FIXING_DATE,
              ],
              hidden: true,
            },
            {
              formControlNames: [
                COUPON_EVENT_SCHEDULE_START_END,
                COUPON_EVENT_BARRIER_TOUCH,
                COUPON_EVENT_AMOUNT,
                COUPON_EVENT_CURRENCY,
                ,
              ],
              readOnly: true,
              hidden: false,
            },
            {
              formControlNames: [COUPON_EVENT_AMOUNT],
              hidden: false,
              readOnly: false,
            },
          ],
        },
        {
          id: LifecycleEventTypeLabel[LifecycleEventType.ISSUER_CALL],
          label: LifecycleEventTypeLabel[LifecycleEventType.ISSUER_CALL],
          effects: [
            {
              formControlNames: [
                COUPON_EVENT_COUPON,
                COUPON_EVENT_SCHEDULE_PAYMENT_FIXING,
                COUPON_EVENT_DAY_COUNT_FRACTION,
                COUPON_EVENT_REFERENCE_RATE,
                COUPON_EVENT_REFERENCE_RATE_FIX,
                COUPON_EVENT_DENOMINATION,
                COUPON_EVENT_FLOOR,
                COUPON_EVENT_CAP,
                COUPON_EVENT_MULTIPLIER,
                COUPON_EVENT_SPREAD,
                COUPON_EVENT_CURRENCY,
                COUPON_EVENT_BARRIER_TOUCH,
              ],
              hidden: true,
            },
            {
              formControlNames: [
                COUPON_EVENT_SCHEDULE_START_END,
                COUPON_EVENT_AMOUNT,
              ],
              readOnly: true,
              hidden: false,
            },
            {
              formControlNames: [COUPON_EVENT_AMOUNT],
              hidden: false,
              readOnly: false,
            },
          ],
        },
        {
          id: LifecycleEventTypeLabel[LifecycleEventType.ISSUE],
          label: LifecycleEventTypeLabel[LifecycleEventType.ISSUE],
          effects: [...ISSUE_OR_INITIAL_FIXING_OR_FINAL_FIXING_EFFECTS],
        },
        {
          id: LifecycleEventTypeLabel[LifecycleEventType.INITIAL_FIXING],
          label: LifecycleEventTypeLabel[LifecycleEventType.INITIAL_FIXING],
          effects: [...ISSUE_OR_INITIAL_FIXING_OR_FINAL_FIXING_EFFECTS],
        },
        {
          id: LifecycleEventTypeLabel[LifecycleEventType.FINAL_FIXING],
          label: LifecycleEventTypeLabel[LifecycleEventType.FINAL_FIXING],
          effects: [...ISSUE_OR_INITIAL_FIXING_OR_FINAL_FIXING_EFFECTS],
        },
        {
          id: LifecycleEventTypeLabel[LifecycleEventType.KNOCK_IN_PUT_DOWNSIDE],
          label:
            LifecycleEventTypeLabel[LifecycleEventType.KNOCK_IN_PUT_DOWNSIDE],
          effects: [
            {
              formControlNames: [
                COUPON_EVENT_COUPON,
                COUPON_EVENT_SCHEDULE_PAYMENT_DATE,
                COUPON_EVENT_DAY_COUNT_FRACTION,
                COUPON_EVENT_REFERENCE_RATE,
                COUPON_EVENT_REFERENCE_RATE_FIX,
                COUPON_EVENT_DENOMINATION,
                COUPON_EVENT_FLOOR,
                COUPON_EVENT_CAP,
                COUPON_EVENT_MULTIPLIER,
                COUPON_EVENT_SPREAD,
                COUPON_EVENT_SCHEDULE_FIXING_DATE,
                COUPON_EVENT_AMOUNT,
              ],
              hidden: true,
            },
            {
              formControlNames: [
                COUPON_EVENT_SCHEDULE_START_END,
                COUPON_EVENT_BARRIER_TOUCH,
                COUPON_EVENT_CURRENCY,
                ,
              ],
              readOnly: true,
              hidden: false,
            },
          ],
        },
      ],
    },
  ],
};
